import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';

import { styles } from './styles';

const Loader = ({ variant = 'paper' }) => {
	return (
		<Paper elevation={2} sx={styles[variant]}>
			<Box sx={styles.centered}>
				<CircularProgress size={56} sx={styles.fabProgress} />
			</Box>
		</Paper>
	);
};

export default Loader;
